import request from '../../http/request'

export const getVideoLink = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/engagement/link/getEngagementLink`, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
